import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { CheckCircleSolidIcon, WarningSolidIcon } from '@stpkg/stand-react';

import { RSToastCloseButton } from '../RSToastCloseButton';

import styles from './index.module.css';

export interface RSToastProps {
  title: string;
  description?: ReactNode;
  variant: 'success' | 'error';
  isVisible: boolean;
  onRequireClosing: () => void;
}

export const RSToast: FC<RSToastProps> = ({
  title,
  description,
  variant,
  isVisible,
  onRequireClosing,
}) => {
  return (
    <div
      className={classnames(
        'box-border',
        'w-full',
        'pc:w-[360px]',
        'h-auto',
        'rounded-[12px]',
        'mt-1',
        'pc:mt-2',
        'relative',
        'bg-white',
        isVisible ? styles.customEnter : styles.customExit,
        styles.customShadow,
      )}
    >
      <div
        className={classnames(
          'absolute',
          'top-0',
          'left-0',
          'h-full',
          'w-[32px]',
          variant === 'success' ? 'bg-green-400' : 'bg-red-700',
          'flex',
          'items-center',
          'justify-center',
          'rounded-l-[12px]',
        )}
      >
        {variant === 'success' ? (
          <CheckCircleSolidIcon
            className="block fill-white"
            width="20"
            height="20"
            viewBox="0 0 48 48"
          />
        ) : (
          <WarningSolidIcon
            className="block fill-white"
            width="20"
            height="20"
            viewBox="0 0 48 48"
          />
        )}
      </div>
      <div
        className={classnames(
          'box-border',
          variant === 'success' ? 'text-gray-1000' : 'text-red-700',
          'w-[calc(100%-32px)]',
          'ml-4',
          'p-2',
          'bg-white',
          'rounded-r-[12px]',
          'border-t',
          'border-r',
          'border-b',
          'border-l-0',
          'border-solid',
          'border-gray-50',
        )}
      >
        <div className="rs-font text-16 pc:text-15 box-border pr-4 font-bold">
          {title}
        </div>
        {description && (
          <div className="rs-font text-13 pc:mt-0.5 pc:text-[12px] box-border font-normal">
            {description}
          </div>
        )}
      </div>
      <div className="absolute right-[2px] top-[2px]">
        <RSToastCloseButton onClick={onRequireClosing} />
      </div>
    </div>
  );
};
